import { render, staticRenderFns } from "./fieldsets.vue?vue&type=template&id=1de1314a&"
import script from "./fieldsets.vue?vue&type=script&lang=js&"
export * from "./fieldsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports